import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CornerFrame } from './ui/CornerFrame';
import { Clock } from 'lucide-react';
export function Proof() {
  return <section className="py-20 bg-bio-dark" data-id="element-270">
      <div className="container mx-auto px-6 max-w-4xl" data-id="element-271">
        <FadeIn data-id="element-272">
          <CornerFrame className="!bg-bio-teal/5 !border-bio-teal/20 p-8 md:p-12 text-center" data-id="element-273">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-bio-teal/10 mb-6" data-id="element-274">
              <Clock className="w-8 h-8 text-bio-teal" data-id="element-275" />
            </div>

            <h2 className="text-2xl md:text-3xl font-bold text-white mb-6 tracking-wide" data-id="element-276">
              WHAT CHANGES IN <span className="text-bio-teal" data-id="element-277">7 DAYS</span>
            </h2>

            <p className="text-lg md:text-xl text-bio-text font-light leading-relaxed mb-6" data-id="element-278">
              Most users report a sharp increase in "Executive Clarity" and the
              disappearance of the 3:00 PM energy crash. This isn't just a sign
              of coffee working; it's the sign of your "Spleen-Qi" returning and
              your mitochondrial voltage stabilizing.
            </p>

            <div className="inline-block border border-bio-teal/30 bg-bio-black px-6 py-3 font-mono text-sm text-bio-teal tracking-widest" data-id="element-279">
              WITHIN ONE WEEK, YOUR "BIOLOGICAL SHIELD" MOVES FROM DORMANT TO
              ACTIVE.
            </div>
          </CornerFrame>
        </FadeIn>
      </div>
    </section>;
}